import { useState } from 'react';
import useDebounce from '../../../../hooks/useDebounce/useDebounce';
import LangEnum from '../../../../lang/LangEnum';
import { useInfiniteClassificationsList } from '../../../../services/modules/classifications/classifications.queries';
import { ClassificationTypeEntityEnum } from '../../../classifications/classification.types';
import { CATALOG_CREATION_CRITERIA_SEARCH_DEBOUNCE_MS } from '../catalogCreationCriteria.consts';
import { CatalogCreationCriteriaSourcePickerProps } from '../catalogCreationCriteria.types';
import CatalogCreationCriteriaValuePicker from './CatalogCreationCriteriaValuePicker';

const CatalogCreationClassificationCriteriaPicker = ({
  selectedIds,
  optionLabelsById,
  operator,
  onBack,
  onApply,
  onOperatorChange,
  onToggleOption,
}: CatalogCreationCriteriaSourcePickerProps) => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, CATALOG_CREATION_CRITERIA_SEARCH_DEBOUNCE_MS);

  const { query } = useInfiniteClassificationsList({
    entity: ClassificationTypeEntityEnum.PRODUCT_COLOR,
    nameOrClassification: debouncedSearch || undefined,
  });

  const options = (query.pagesData ?? []).map(({ id, name, classificationType }) => ({
    id,
    name,
    description: classificationType?.name,
    groupId: classificationType?.id,
  }));

  return (
    <CatalogCreationCriteriaValuePicker
      title={LangEnum.CATALOGS_CREATION_MODAL_CRITERIA_CLASSIFICATION}
      search={search}
      isLoading={query.isFetching}
      options={options}
      selectedIds={selectedIds}
      optionLabelsById={optionLabelsById}
      operator={operator}
      operatorHint={LangEnum.CATALOGS_CREATION_MODAL_CRITERIA_CLASSIFICATION_OPERATOR_HINT}
      onBack={onBack}
      onApply={onApply}
      onSearchChange={setSearch}
      onOperatorChange={onOperatorChange}
      onToggleOption={onToggleOption}
      onScrollEnd={query.fetchNextPage}
    />
  );
};

export default CatalogCreationClassificationCriteriaPicker;
